module.exports = __webpack_public_path__ + "static/img/效率.6351f866.png";